<template>
  <span>
    <span style="text-align: left">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-autocomplete
          v-if="lockval == false"
          :loading="loading"
          :items="itemsauto"
          :search-input.sync="search"
          v-model="select"
          clear-icon="clear"
          item-text="v"
          item-value="k"
          flat
          clearable
          required
          :rules="crud.evalrules(campo)"
          :placeholder="T('Digite para buscar')"
          :hint="T(campo.cmp_dica)"
          persistent-hint
          solo
        ></v-autocomplete>

        <div class="pt-4" v-else>{{ T("Módulo atual") }}</div>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <span :class="{ 'text-xs-center': modo == 'list' }">{{
          valoramostrar
        }}</span>
      </template>

      <template v-if="modo == 'filtro'">
        <v-autocomplete
          :loading="loading"
          :items="itemsauto"
          :search-input.sync="search"
          v-model="select"
          clear-icon="clear"
          item-text="v"
          item-value="k"
          flat
          clearable
          required
          :rules="crud.evalrules(campo)"
          :placeholder="T('Digite para buscar')"
          :hint="T(campo.cmp_dica)"
          persistent-hint
        ></v-autocomplete>
      </template>
    </span>
  </span>
</template>

<script>
import axios from "axios";
const Api = global.Api;
try {
  var bus = require("@/admin/elements/inc/bus").default;
} catch (err) {
  var bus = require("@/framework/admin/elements/inc/bus").default;
}

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      loading: false,
      lockval: false,
      search: null,
      select: this.preLoad(this.value),
      itemsauto: (() => {
        //return [];
        if (this.row._extra) {
          let array = this.row._extra[this.campo.cmp_coluna];
          return array;
        }
        if (this.crud.metadataextra) {
          let array = this.crud.metadataextra[this.campo.cmp_coluna];
          return array;
        }
        return [];
      })(),
    };
  },
  created() {
    bus.$off(
      "crud_" + this.crud.sid + "_" + this.campo.cmp_coluna + "_refresh"
    );
    bus.$on(
      "crud_" + this.crud.sid + "_" + this.campo.cmp_coluna + "_refresh",
      () => {
        this.fazAsyncLimpar();
      }
    );
  },
  destroy() {
    bus.$off(
      "crud_" + this.crud.sid + "_" + this.campo.cmp_coluna + "_refresh"
    );
  },

  computed: {
    valoramostrar() {
      if (this.value == null) return "";

      if (
        this.row[
          "_join_" +
            this.campo.cmp_coluna +
            "_" +
            this.crud.module +
            "_" +
            this.campo.cmp_join_tabela
        ] == null
      )
        return "";

      return this.row[
        "_join_" +
          this.campo.cmp_coluna +
          "_" +
          this.crud.module +
          "_" +
          this.campo.cmp_join_tabela
      ]._joined;
    },
  },

  mounted() {
    if (this.crud.localsession != null) {
      let locases = this.crud.localsession[this.crud.sid];
      if (
        this.modo != "filtro" &&
        locases.joined != null &&
        locases.joined == this.campo.cmp_coluna &&
        this.row != null &&
        this.row._extra != null &&
        this.row._extra[this.campo.cmp_coluna] != null
      ) {
        if (locases.joinedid < 0) {
          this.value = locases.joinedid;
          this.$emit("input", locases.joinedid);
          this.lockval = { k: locases.joinedid, v: "Módulo atual" };
        } else {
          this.value = locases.joinedid;
          this.$emit("input", locases.joinedid);
          this.lockval = this.row._extra[this.campo.cmp_coluna].filter(
            (v) => v.k == locases.joinedid
          );
          this.lockval =
            this.lockval != null && this.lockval.length > 0
              ? this.lockval[0]
              : false;
        }
      }
    }
  },

  methods: {
    preLoad(myval) {
      if (myval == undefined) return null;
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
    alterouSelectRadio() {
      let params = this.getComponentParam("updates");
      if (params != null && params != "") {
        params
          .split(",")
          .map((v) => v.trim())
          .forEach((alvo) => {
            bus.$emit("crud_" + this.crud.sid + "_" + alvo + "_refresh");
          });
      }
    },

    fazAsyncLimpar() {
      this.select = null;
      this.itemsauto = [];
    },

    querySelections(v) {
      this.loading = true;
      // Simulated ajax query

      let clone = _.clone(this.crud.localsession[this.crud.sid]);

      delete clone["filtro"];

      if (this.modo != "filtro")
        clone.master = _.pickBy(
          this.crud.form,
          (v, k) => !_.startsWith(k, "_")
        );
      else clone.master = _.clone(this.crud.localsession[this.crud.sid]).filtro;

      let credentials = {
        module: this.crud.module,
        query: v,
        column: this.campo.cmp_coluna,
        localsession: clone,
        action: "actionComponentUpdate",
      };
      Api()
        .post("admin/crud/async", credentials)
        .then((result) => {
          console.log(result);
          this.itemsauto = [];
          if (result.data.output != null) this.itemsauto = result.data.output;

          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },

    select(val) {
      this.$emit("input", this.preUpdate(val));

      setTimeout(() => this.alterouSelectRadio(), 500);
    },
  },
};
</script>

<style scoped></style>
